import {
  CategoryType,
  Mission,
  useTradeMission,
  useMissionDetail,
} from '@/app/hooks/trade/tradeMission';
import { useMemo, useState } from 'react';
import SubMissionTab from '../../SubMissionTab';
import { getMissionTemplateCode, MissionCode } from '../../utils';
import Description from './Description';
import * as S from './styles';
import RewardLoading from '../RewardLoading';
import { useTranslation } from 'react-i18next';

export enum SubMission {
  DEPOSIT = 'Cumulative Net Deposit Mission',
  TRADING_VOLUME = 'Cumulative Trading Volume Mission',
  DURATION = 'Duration Mission',
}

const subMissions = [
  SubMission.DEPOSIT,
  SubMission.TRADING_VOLUME,
  SubMission.DURATION,
];

const TradeDetails = () => {
  const { t } = useTranslation();
  const [currentSubMission, setCurrentSubMission] = useState<SubMission>(
    subMissions[0]
  );

  const { data, getMissionReward, isLoading } =
    useTradeMission(CategoryType.TRADING); // 카테고리별 API 호출
  const tradingMissions = data?.missions ?? []; // 이미 필터링된 데이터

  const depositMissions = useMemo(
    () =>
      tradingMissions.filter(
        (m) => getMissionTemplateCode(m.code) === MissionCode.NET_DEPOSIT_GOAL
      ),
    [tradingMissions]
  );

  const volumeMissions = useMemo(
    () =>
      tradingMissions.filter(
        (m) => getMissionTemplateCode(m.code) === MissionCode.NET_VOLUME_GOAL
      ),
    [tradingMissions]
  );

  const periodMissions = useMemo(
    () =>
      tradingMissions.filter(
        (m) => getMissionTemplateCode(m.code) === MissionCode.PERIOD_MISSION
      ),
    [tradingMissions]
  );

  // useSWR로 미션 상세 조회 (3초 캐싱)
  const { data: detailDepositMission } = useMissionDetail(
    depositMissions[0]?.id
  );
  const { data: detailVolumeMission } = useMissionDetail(volumeMissions[0]?.id);
  const { data: detailPeriodMission } = useMissionDetail(periodMissions[0]?.id);

  // 추후 조건문에 기간미션 추가해야함.
  if (
    isLoading ||
    !depositMissions ||
    !volumeMissions ||
    !detailDepositMission ||
    !detailVolumeMission
  ) {
    return <RewardLoading messageKey="loadingTradingMission" />;
  }

  return (
    <S.Container>
      <SubMissionTab
        currentSubMission={currentSubMission}
        setCurrentSubMission={setCurrentSubMission}
        subMissions={subMissions}
      />

      <Description
        currentSubMission={currentSubMission}
        depositMission={depositMissions[0]}
        volumeMission={volumeMissions[0]}
        periodMission={periodMissions[0]}
        detailDepositMission={detailDepositMission}
        detailVolumeMission={detailVolumeMission}
        detailPeriodMission={detailPeriodMission}
        getMissionReward={getMissionReward}
      />
      {/* <VolumeMission volumeMissions={filterMissions.advanced} /> */}
    </S.Container>
  );
};

export default TradeDetails;
